module.exports = __webpack_public_path__ + "img/facebook.759b9937.svg";